var _circle, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPetsshopCat = function SvgPetsshopCat(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 90,
    fill: "none",
    viewBox: "0 0 90 90",
    ref: ref
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    fill: "#FF5100"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "svg-3514004897__a",
    width: 90,
    height: 90,
    x: 0,
    y: 0,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    fill: "#FFF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#svg-3514004897__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M81.99 73.15c-6.969-1.255-12.637-6.277-14.42-13.09l-5.026-19.193C59.962 27.479 49.669 12.43 40.686 12.43v14.905c-5.368.072-12.226 1.048-15.9 4.348-2.765 2.465-3.712 11.45-8.565 11.45-.78 0-1.536.27-2.14.76a3.283 3.283 0 0 0-.968 3.49l1.311 4.365c1.165 3.895 5.288 9.148 12.319 10.674l5.73 1.241s.446-2.527.446 7.494c0 5.844-2.374 11-3.252 18.143L59.5 95c4.592-.007 15.2-7.206 18.858-9.967a20.97 20.97 0 0 0 7.551-11.03 57 57 0 0 0-3.92-.853M30.244 42.212a2.97 2.97 0 0 1-2.092-.86 2.94 2.94 0 0 1-.867-2.08 2.93 2.93 0 0 1 .867-2.079 2.96 2.96 0 0 1 2.092-.86c.783.001 1.534.311 2.087.863a2.93 2.93 0 0 1 .865 2.077 2.93 2.93 0 0 1-.859 2.088 2.96 2.96 0 0 1-2.093.868z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPetsshopCat);
export default ForwardRef;